import { RelatorioComposicaoReceitasHorizontalItem } from "../typings";

import http from "infra/http";
import { RelatorioReceitasHorizontalQueryParams } from "../typings/index";
import { useQuery } from "react-query";
import { PaginateResult } from "core/resources/types/shared";

function useRelatorioComposicaoReceitasHorizontal(
  params: RelatorioReceitasHorizontalQueryParams
) {
  return useQuery(
    [`/v1/relatorios/financeiro/composicao-receitas-horizontal/paginado`, params],
    async () => {
      const { data } = await http.get<PaginateResult<RelatorioComposicaoReceitasHorizontalItem> & {todasAsCategorias: {id: string; nome:string;breadcrumb:string}[]}>(
        "/v1/relatorios/financeiro/composicao-receitas-horizontal/paginado",
        {
          params,
        }
      );

      return data;
    },
  );
}

export default useRelatorioComposicaoReceitasHorizontal;
